module.exports = __webpack_public_path__ + "media/images/responsive/fairs/event_detail/icon_try_on_kimono-5e161a8a9120fccea6588ddfd7cad0df.png";